import React from 'react';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  containerClassName?: string;
  variant?: 'default' | 'green' | 'orange' | 'gray';
}
export function Input({
  label,
  error,
  leftIcon,
  rightIcon,
  className = '',
  containerClassName = '',
  variant = 'default',
  disabled,
  ...props
}: InputProps) {
  const variantStyles = {
    default: 'border-slate-300 focus:border-blue-500 focus:ring-blue-500 bg-white',
    green: 'border-green-300 focus:border-green-500 focus:ring-green-500 bg-green-50/50',
    orange: 'border-orange-300 focus:border-orange-500 focus:ring-orange-500 bg-orange-50/50',
    gray: 'border-slate-200 bg-slate-100 text-slate-600 font-medium'
  };
  const activeVariant = disabled ? 'gray' : variant;
  // Extract width classes (w-XX) to apply on container, not input
  const widthMatch = className.match(/\bw-\S+/g);
  const widthClass = widthMatch ? widthMatch.join(' ') : '';
  const inputClassName = className.replace(/\bw-\S+/g, '').trim();
  return <div className={`flex flex-col gap-1.5 ${widthClass} ${containerClassName}`} data-id="element-375">
      {label && <label className="text-sm font-medium text-slate-700" data-id="element-376">{label}</label>}
      <div className="relative flex items-center" data-id="element-377">
        {leftIcon && <div className="absolute left-3 text-slate-400 flex items-center justify-center" data-id="element-378">
            {leftIcon}
          </div>}
        <input disabled={disabled} className={`
            w-full rounded-lg border px-3 py-2 text-sm transition-colors
            focus:outline-none focus:ring-2 focus:ring-opacity-20
            disabled:cursor-not-allowed disabled:opacity-100
            ${leftIcon ? 'pl-9' : ''}
            ${rightIcon ? 'pr-9' : ''}
            ${variantStyles[activeVariant]}
            ${error ? 'border-red-500 focus:border-red-500 focus:ring-red-500' : ''}
            ${inputClassName}
          `} {...props} data-id="element-379" />
        {rightIcon && <div className="absolute right-3 text-slate-400 flex items-center justify-center" data-id="element-380">
            {rightIcon}
          </div>}
      </div>
      {error && <span className="text-xs text-red-500" data-id="element-381">{error}</span>}
    </div>;
}